import config from 'SRC/config/config.yaml'

export const imagesCDN = config.mediaCDN
